var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4645 9.55493L9.59031 10.321L5.21924 14.8081L11.8851 10.9777L10.7924 9.88326L10.4645 9.55493Z",
    fill: "#43B02A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2887 9.22663C14.0701 9.11719 12.4309 8.13221 12.1031 7.91333L11.0103 9.00775L10.5732 9.44551L10.9011 9.77384L11.9938 10.8683L14.1794 9.55496C14.2887 9.55496 14.2887 9.44551 14.2887 9.33607C14.3979 9.33607 14.2887 9.33607 14.2887 9.22663Z",
    fill: "#43B02A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7924 9.00771L11.8851 7.91329L9.04393 6.27167L5.21924 3.97339L10.4645 9.22659L10.7924 9.00771Z",
    fill: "#43B02A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3548 9.44572L9.37127 8.3513L4.78164 3.97363C4.67236 3.97363 4.67236 4.08307 4.67236 4.19252V14.8084V14.9178L9.15271 10.5401L10.3548 9.44572Z",
    fill: "#43B02A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9283 18.2007H3.14286C1.83154 18.2007 0.73877 17.1063 0.73877 15.793V2.98829C0.73877 1.67498 1.83154 0.580566 3.14286 0.580566H15.9283C17.2396 0.580566 18.3323 1.67498 18.3323 2.98829V15.793C18.3323 17.2157 17.3489 18.2007 15.9283 18.2007ZM3.14286 1.01833C2.05009 1.01833 1.17588 1.89387 1.17588 2.98829V15.793C1.17588 16.8874 2.05009 17.7629 3.14286 17.7629H15.9283C17.021 17.7629 17.8952 16.8874 17.8952 15.793V2.98829C17.8952 1.89387 17.021 1.01833 15.9283 1.01833H3.14286Z",
    fill: "#43B02A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.20665fb35e9f056bd6a2c6ac60e8136d.svg";
export { ForwardRef as ReactComponent };